module.exports = __webpack_public_path__ + "back-arrow.svg";